import { render, staticRenderFns } from "./YearGroupDetail.vue?vue&type=template&id=3ec318ed&scoped=true"
import script from "./YearGroupDetail.vue?vue&type=script&lang=js"
export * from "./YearGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./YearGroupDetail.vue?vue&type=style&index=0&id=3ec318ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec318ed",
  null
  
)

export default component.exports